export default __webpack_public_path__ + "static/media/news4.9957dd8e.webp";